import React from "react";
import { MapContainer, TileLayer } from 'react-leaflet';
import { useData } from '../../contexts/DataContext';
import { MarkerWithPopup } from './markerWindows'; // Assuming MarkerWithPopup is in the same directory
import 'leaflet/dist/leaflet.css';

const MapBox = () => {
  const { markers } = useData();
  const defaultPosition = [40, -100]; // Default center of the map

  return (
    <div className="w-full h-full">
      <MapContainer 
        center={defaultPosition} 
        zoom={4} 
        style={{ width: '100%', height: '100%' }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {markers.map((marker) => (
          <MarkerWithPopup 
            key={marker.id} 
            data={marker}
          />
        ))}
      </MapContainer>
    </div>
  );
};

export default MapBox;
